export const NEMESES_DB_KEY = 'nemeses-1.8'
